export default __webpack_public_path__ + "static/media/tndr-busd.1bd9a60c.png";